import { createRouter, createWebHistory } from 'vue-router'
import store from './stores/store.js';
/*import HomePage from './components/pages/HomePage.vue'
import Layout from './components/Layout.vue'
import TestPage from './components/pages/TestPage.vue'
import NotFound from './components/pages/NotFound.vue'
import UsuariosPage from './components/pages/UsuariosPage.vue'
import UserAuth from './components/pages/auth/UserAuth.vue'*/

var facturacion = (localStorage.getItem('no_factura') == 1 || localStorage.getItem('sistema_verifactu') == 1) ? 'Registro contable' : 'Facturación';
var isFirefox = typeof InstallTrigger !== 'undefined';
var router = null;
if(isFirefox){
    router = createRouter({
        history: createWebHistory(),
        companias:'compañias',
        routes: [
            {
                path: '/',
                redirect: {
                    name: 'Inicio'
                }
            },
            {
                path: '/login',
                name: 'login',
                component: () => import("./components/pages/auth/UserAuth.vue"),
            },
            {
                path: '/app',
                name: 'Inicio',
                component: () => import("./components/Layout.vue"),
                children: [
                    {
                        path: '/',
                        component: () => import("./components/pages/HomePage.vue"),
                    },
                    {
                        path: '/companias',
                        name: 'Compañías',
                        component: () => import("./components/pages/companyias/CompanyiasPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/companias/:id',
                        name: 'Compañía',
                        component: () => import('./components/pages/companyias/Compania.vue'),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/usuarios',
                        name: 'Usuarios',
                        component: () => import("./components/pages/UsuariosPage.vue"),
                        children: [
                            
                        ],
                        meta: { permisos: ['Super Administración']}
                    },
                    {
                        path: '/rgpd',
                        name: 'Rgpd',
                        component: () => import("./components/pages/RGPD.vue"),
                        children: [
                            
                        ],
                        meta: { permisos: ['Super Administración']}
                    },
                    {
                        path: '/usuarios/:id',
                        name: 'Usuario',
                        component: () => import('./components/pages/usuarios/Usuario.vue'),
                        props: ruta => ({id: +ruta.params.id}),
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Super Administración']
                        }
                        
                    },
                    {
                        path: '/usuarios/crear',
                        name: 'Crear Usuarios',
                        component: () => import('./components/pages/usuarios/Usuario.vue'),
                          props: ({id: 0}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Super Administración']
                        }  
                    },
                
                    {
                        path: '/servicios/:id',
                        name: 'Servicio',
                        component: () => import('./components/pages/servicios/Servicio.vue'),
                        props: ruta => ({id: +ruta.params.id}),
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/baremos',
                        name: 'Baremos',
                        component: () => import("./components/pages/TestPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/configuracion/braremos',
                        name: 'Configuración baremos',
                        component: () => import("./components/pages/configuracion/baremos/baremos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/especialidades/:id',
                        name: 'Especialidad',
                        component: () => import('./components/pages/especialidades/Especialidad.vue'),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
    
                       
                    },
                    {
                        path: '/especialidades',
                        name: 'Especialidades',
                        component: () => import("./components/pages/especialidades/EspecialidadesPage.vue"),
                         props: true,
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/equiposMarcas',
                        name: 'EquiposMarcas',
                        component: () => import("./components/pages/configuracion/equiposmarcas/EquiposMarcasPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
            
                    },
                    {
                        path: '/gestorTipos',
                        name: 'GestorTipos',
                        component: () => import("./components/pages/configuracion/gestortipo/gestortiposPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/SMS',
                        name: 'SMS',
                        component: () => import("./components/pages/configuracion/sms/sms.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/centralita',
                        name: 'Centralita',
                        component: () => import("./components/pages/configuracion/centralita/centralita.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/escritorio',
                        name: 'Escritorio',
                        props: route => ({ tipo_buscador: route.query.tipo_buscador,titulo: route.query.titulo }),
                        component: () => import("./components/pages/escritorio/Escritorio.vue"),
                    },
                    {
                        path: '/Eventos',
                        name: 'Eventos',
                        component: () => import("./components/pages/configuracion/eventos/Eventos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/Encuestas',
                        name: 'Encuestas',
                        component: () => import("./components/pages/configuracion/encuestas/Encuestas.vue"),
                        meta: { permisos: ['Administración', 'Super Administración'] }
                    },
                    {
                        path: '/DocumentacionRequerida',
                        name: 'Documentación Requerida',
                        component: () => import("./components/pages/configuracion/documentacionrequerida/DocumentacionRequerida.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/GestionDocumentos',
                        name: 'Gestión Documentos',
                        component: () => import("./components/pages/configuracion/gestiondocumentos/GestionDocumentos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/AutoVisitas',
                        name: 'Auto Visitas',
                        component: () => import("./components/pages/configuracion/autovisitas/AutoVisitas.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/GestionCampos',
                        name: 'Gestión Campos',
                        component: () => import("./components/pages/configuracion/gestioncampos/GestionCampos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                   /* {
                        path: '/servicios',
                        name: 'Servicios',
                        props: ({servicios: true}), 
                        component: () => import("./components/pages/escritorio/Escritorio.vue"),
                    },*/
                    /*   {
                        path: '/planning',
                        name: 'Planning',
                        component: () => import("./components/pages/servicios/planning/planning.vue"),
                    },*/
                    {
                        path: '/planningGeografico',
                        name: 'Planning Geográfico',
                        component: () => import("./components/pages/planninggeografico/PlanningGeografico.vue"),
                    },
                    {
                        path: '/facturacionOperarios',
                        name: 'Autofacturación Operarios',
                        component: () => import("./components/pages/facturacionoperarios/FacturacionOperarios.vue"),
                    },
                    {
                        path: '/liquidacionOperarios',
                        name: 'Liquidación Operarios',
                        component: () => import("./components/pages/liquidacionoperarios/LiquidacionOperarios.vue"),
                    },
                    {
                        path: '/informesAutovisitas',
                        name: 'Informes Autovisitas',
                        component: () => import("./components/pages/informesautovisitas/InformesAutovisitas.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeAgendas',
                        name: 'Informe Agendas',
                        component: () => import("./components/pages/informeagendas/InformeAgendas.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeCalidadOperarios',
                        name: 'Informe Calidad Operarios',
                        component: () => import("./components/pages/informecalidadoperarios/InformeCalidadOperarios.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeGremiosExpediente',
                        name: 'Informe Gremios por Expediente',
                        component: () => import("./components/pages/informegremiosexpediente/InformeGremiosExpediente.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeRentabilidadGlobal',
                        name: 'Informe Rentabilidad Global',
                        component: () => import("./components/pages/informerentabilidadglobal/InformeRentabilidadGlobal.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeRentabilidadGlobalFacturacion',
                        name: 'Informe Rentabilidad Global de Facturación',
                        component: () => import("./components/pages/informerentabilidadglobalfacturacion/InformeRentabilidadGlobalFacturacion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeTipoDanyos',
                        name: 'Informe Tipos de Daños',
                        component: () => import("./components/pages/informetipodanyos/InformeTipoDanyos.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeTramitacion',
                        name: 'Informe Tramitacion',
                        component: () => import("./components/pages/informetramitacion/InformeTramitacion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeRentabilidadOperarios',
                        name: 'Informe Rentabilidad Operarios',
                        component: () => import("./components/pages/informerentabilidadoperarios/InformeRentabilidadOperarios.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeRentabilidadOperariosCompanyias',
                        name: 'Informe Rentabilidad Operarios Companyias',
                        component: () => import("./components/pages/informerentabilidadoperarioscompanyias/InformeRentabilidadOperariosCompanyias.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeRentabilidadTrabajosOperariosCompanyias',
                        name: 'Informe Rentabilidad Trabajos Operarios Companyias',
                        component: () => import("./components/pages/informerentabilidadtrabajosoperarioscompanyias/informerentabilidadtrabajosoperarioscompanyias.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeTrabajosNoLiquidados',
                        name: 'Informe Trabajos No Liquidados',
                        component: () => import("./components/pages/informetrabajosnoliquidados/InformeTrabajosNoLiquidados.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeTrabajosSubsanadosCompanyia',
                        name: 'Informe Trabajos Subsanados',
                        component: () => import("./components/pages/informetrabajossubsanadoscompanyia/InformeTrabajosSubsanadosCompanyia.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/importacionAutofacturasCompania',
                        name: 'Importacion Autofacturas Compañía',
                        component: () => import("./components/pages/importacionautofacturascompania/ImportacionAutofacturasCompania.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeBaremos',
                        name: 'Informe Baremos',
                        component: () => import("./components/pages/informebaremos/InformeBaremos.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeFichajes',
                        name: 'Informe Fichajes',
                        component: () => import("./components/pages/informefichajes/InformeFichajes.vue"),
                    },
                    {
                        path: '/facturacionAlbaranes',
                        name: 'Albaranes',
                        component: () => import("./components/pages/facturacionalbaranes/FacturacionAlbaranes.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeVerifactu',
                        name: 'Informe Verifactu',
                        component: () => import("./components/pages/informeverifactu/InformeVerifactu.vue"),
                    },
                    {
                        path: '/informeSatisfaccion',
                        name: 'Informe Satisfacción',
                        component: () => import("./components/pages/informesatisfaccion/InformeSatisfaccion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/facturacion',
                        name: facturacion,
                        component: () => import("./components/pages/Facturacion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/peritos',
                        name: 'Peritos',
                        component: () => import("./components/pages/peritos/PeritosPage.vue"),
                    },
                    {
                        path: '/peritos/:id',
                        name: 'Perito',
                        component: () => import("./components/pages/peritos/Perito.vue"),
                         props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },                    
                    {
                        path: '/comerciales',
                        name: 'Comerciales',
                        component: () => import("./components/pages/comerciales/ComercialesPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                        
                    },
                    {
                        path: '/comerciales/:id',
                        name: 'comercial',
                        component: () => import("./components/pages/comerciales/Comercial.vue"),
                         props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/empresas',
                        name: 'Empresas',
                        component: () => import("./components/pages/empresas/EmpresasPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                                    
                         {
                        path: '/empresaprincipal',
                        name: 'DatosEmpresa',
                        component: () => import("./components/pages/empresaprincipal/DatosEmpresa.vue"),
                    },
                    {
                        path: '/empresas/:id',
                        name: 'Empresa',
                        component: () => import("./components/pages/empresas/Empresa.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/RGA',
                        name: 'RGA',
                        target: "_blank",
                        component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/modulos/plataforma_pas/plataforma_pas.php";
                             window.open(aux,'_blank');
                        }
                    },
                    {
                        path: '/Informes',
                         name: 'Informes',
                         target: "_blank",
    
                         component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/informes.php";
                             window.open(aux,'_blank');
                                }
                       
                    },
                    {
                        path: '/Control',
                         name: 'Control',
                         target: "_blank",
    
                         component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/informes_control.php";
                             window.open(aux,'_blank');
                                }
                       
                    },
                    {
                        path: '/seguimientoTramitadores',
                        name: 'Seguimiento Tramitadores',
                        component: () => import("./components/pages/SeguimientoTramitadores.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoOperarios',
                        name: 'Seguimiento Operarios',
                        component: () => import("./components/pages/SeguimientoOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoAlarmasUsuarios',
                        name: 'Seguimiento Alarmas Usuarios',
                        component: () => import("./components/pages/SeguimientoAlarmasUsuarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoAlarmasOperarios',
                        name: 'Seguimiento Alarmas Operarios',
                        component: () => import("./components/pages/SeguimientoAlarmasOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoSms',
                        name: 'Seguimiento SMS',
                        component: () => import("./components/pages/SeguimientoSms.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/GuardiasOperarios',
                        name: 'Guardias Operarios',
                        component: () => import("./components/pages/GuardiasOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/vacaciones',
                        name: 'Vacaciones',
                        component: () => import("./components/pages/controlvacaciones/VacacionesPage.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/periodosOcupadosOperarios',
                        name: 'Periodos Ocupados Operarios',
                        component: () => import("./components/pages/PeriodosOcupadosOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    /* {
                        path: '/bloqueos',
                         name: 'Bloqueos',
                         target: "_blank",
    
                         component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/planning_mensual.php?bloqueos=si";
                             window.open(aux,'_blank');
                                },
                        meta: { permisos: ['soporte']}
                        
                       
                    },*/
                    {
                        path: '/bloqueos',
                        name: 'Bloqueos',
                            
                        component: () => import("./components/pages/BloqueosPage.vue"),
                        
                       
                    },
                    {
                        path: '/bancos',
                        name: 'Bancos',
                        component: () => import("./components/pages/bancos/BancosPage.vue"),
                    },
                    {
                        path: '/bancos/:id',
                        name: 'Banco',
                        component: () => import("./components/pages/bancos/Banco.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    ///
                    {
                        path: '/correos',
                        name: 'Correos',
                        component: () => import("./components/pages/correos/CorreosPage.vue"),
                        meta: { permisos: ['Super Administración']}
                    },
                    {
                        path: '/ste',
                        name: 'Sigue tu expediente',
                        component: () => import("./components/pages/ste/ste.vue"),
                        meta: { permisos: ['soporte', 'Super Administración']}
                    },
                    {
                        path: '/interpwgs',
                        name: 'Interpwgs',
                        component: () => import("./components/pages/interpwgs/Interpwgs.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/correos/:id',
                        name: 'Correo',
                        component: () => import("./components/pages/correos/Correos.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Super Administración']
                        }
                    },
                    {
                        path: '/planning',
                        name: 'Planning',
                        component: () => import("./components/pages/PlanningPage.vue"),
                    },
                    {
                        path: '/whatsapp',
                        name: 'WhatsApp',
                        component: () => import("./components/pages/WhatsAppPage.vue"),
                    },  
                    {
                        path: '/chat',
                        name: 'Chat',
                        component: () => import("./components/pages/ChatPage.vue"),
                    },     
                    {
                        path: '/configuracion',
                        name: 'Configuración',
                        component: () => import("./components/pages/configuracion/Configuracion.vue"),
                    },
                    {
                        path: '/clientes',
                        name: 'Clientes',
                        component: () => import("./components/pages/clientes/ClientesPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/clientes/:id',
                        name: 'Cliente',
                        component: () => import("./components/pages/clientes/Cliente.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']

                        }
                    },
                    {
                        path: '/configuracion-exportacion',
                        name: 'Exportación contable',
                        component: () => import("./components/pages/configuracion/facturacion/exportacion.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/lineasfacturacion',
                        name: 'Líneas '+facturacion,
                        component: () => import("./components/pages/lineasfacturacion/LineasFacturacionPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/lineasfacturacion/:id',
                        name: 'Línea '+facturacion,
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: { permisos: ['Administración', 'Super Administración']}
                        }
                    },
                    {
                        path: '/lineasfacturacion/crear',
                        name: 'Crear Líneas '+facturacion,
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ({id: 0}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: { permisos: ['Administración', 'Super Administración']}
                        }
                    },
                    //Se usa???
                    {
                        path: '/lineasverifactu',
                        name: 'Líneas VeriFactu',
                        component: () => import("./components/pages/lineasfacturacion/LineasFacturacionPage.vue"),
                        props: ruta => ({id:+ruta.params.id,verifactu:1}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: { permisos: ['Administración', 'Super Administración']}
                        }
                    },
                    {
                        path: '/lineasverifactu/:id',
                        name: 'Línea VeriFactu',
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ruta => ({id:+ruta.params.id,verifactu:1}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: { permisos: ['Administración', 'Super Administración']}
                        }
                    },
                    {
                        path: '/lineasverifactu/crear',
                        name: 'Crear Líneas VeriFactu',
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                            props: ({id:0,verifactu:1}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: { permisos: ['Administración', 'Super Administración']}
                        }
                    },
                    {
                        path: '/mensajespredefinidos',
                        name: 'Mensajes Predefinidos',
                        component: () => import("./components/pages/configuracion/mensajespredefinidos/MensajesPredefinidosLista.vue"),
                        meta: {permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/mensajespredefinidos/:id',
                        name: 'Mensaje Predefinido',
                        component: () => import("./components/pages/configuracion/mensajespredefinidos/MensajePredefinido.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/proveedores',
                        name: 'Proveedores',
                        component: () => import("./components/pages/proveedores/ProveedoresPage.vue"),
                    },
                    {
                        path: '/proveedores/:id',
                        name: 'Proveedor',
                        component: () => import("./components/pages/proveedores/Proveedor.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        
                        path: '/operarios',
                        name: 'Operarios',
                        component: () => import("./components/pages/operarios/OperariosPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/operarios/:id',
                        name: 'Operario',
                        component: () => import("./components/pages/operarios/Operario.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                            meta: {
                                titulo: ruta => ruta.params.id,
                                permisos: ['Facturación', 'Administración', 'Super Administración']
                            }
                    },
                    {
                        path: '/estadospendientes',
                        name: 'Estados Pendientes',
                        component: () => import("./components/pages/configuracion/estadospendientes/EstadosPendientesPage.vue"),
                        meta: { permisos: ['soporte', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/estadospendientes/:id',
                        name: 'Estado Pendiente',
                        component: () => import("./components/pages/configuracion/estadospendientes/EstadosPendientes.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['soporte', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/tiposdanyo',
                        name: 'Tipos de daño',
                        component: () => import("./components/pages/configuracion/tiposdanyo/TiposDanyoPage.vue"),
                        meta: { permisos: ['soporte', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/coberturasoperarios',
                        name: 'CoberturasOperarios',
                        component: () => import("./components/pages/configuracion/coberturasoperarios/CoberturasOperarios.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/tiposdanyo/:id',
                        name: 'Tipo Daño',
                        component: () => import("./components/pages/configuracion/tiposdanyo/TiposDanyos.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['soporte', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/condiciones',
                        name: 'Condiciones Presupuestos',
                        component: () => import("./components/pages/configuracion/condicionespresupuestos/CondicionesPresupuestosPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/condiciones/:id',
                        name: 'Condición Presupuesto',
                        component: () => import("./components/pages/configuracion/condicionespresupuestos/CondicionesPresupuestos.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/test',
                        name: 'Test',
                        component: () => import("./components/pages/TestPage.vue"),
                    },
                    {
                        path: '/:notFound(.*)',
                        component: () => import("./components/pages/NotFound.vue"),
                    },
                    {
                        path: '/pedidos',
                        name: 'Pedidos',
                        component: () => import("./components/pages/pedidos/Pedidos.vue"),
                    },
                    {
                        path: '/servicio/:id',
                        name: 'Nuevo servicio',
                        component: () => import("./components/pages/servicios/NuevoServicio.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/festivos',
                        name: 'Festivos',
                        component: () => import("./components/pages/festivos/Festivos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                ]
            },
    
    
            {
                path: '/:notFound(.*)',
                component: () => import("./components/pages/NotFound.vue"),
            },
        ]
    });
}else{
    router = createRouter({
        history: createWebHistory(),
        companias:'compañias',
        routes: [
            {
                path: '/',
                redirect: {
                    name: 'Inicio'
                }
            },
            {
                path: '/login',
                name: 'login',
                component: () => import("./components/pages/auth/UserAuth.vue"),
            },
            {
                path: '/app',
                name: 'Inicio',
                component: () => import("./components/Layout.vue"),
                children: [
                    {
                        path: '/',
                        component: () => import("./components/pages/HomePage.vue"),
                    },
                    {
                        path: '/companias',
                        name: 'Compañías',
                        component: () => import("./components/pages/companyias/CompanyiasPage.vue"),
                        meta: {permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/companias/:id',
                        name: 'Compañía',
                        component: () => import('./components/pages/companyias/Compania.vue'),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/usuarios',
                        name: 'Usuarios',
                        component: () => import("./components/pages/UsuariosPage.vue"),
                        children: [
                            
                        ],
                        meta: {permisos: ['Super Administración']}
                    },
                    {
                        path: '/rgpd',
                        name: 'Rgpd',
                        component: () => import("./components/pages/RGPD.vue"),
                        children: [
                            
                        ],
                        meta: { permisos: ['Super Administración']}
                    },
                    {
                        path: '/usuarios/:id',
                        name: 'Usuario',
                        component: () => import('./components/pages/usuarios/Usuario.vue'),
                        props: ruta => ({id: +ruta.params.id}),
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: {permisos: ['Super Administración']}
                        }
                        
                    },
                    {
                        path: '/usuarios/crear',
                        name: 'Crear Usuarios',
                        component: () => import('./components/pages/usuarios/Usuario.vue'),
                          props: ({id: 0}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: {permisos: ['Super Administración']}
                        }  
                    },
                
                    {
                        path: '/servicios/:id',
                        name: 'Servicio',
                        component: () => import('./components/pages/servicios/Servicio.vue'),
                        props: ruta => ({id: +ruta.params.id}),
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/baremos',
                        name: 'Baremos',
                        component: () => import("./components/pages/TestPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/configuracion/braremos',
                        name: 'Configuración baremos',
                        component: () => import("./components/pages/configuracion/baremos/baremos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/especialidades/:id',
                        name: 'Especialidad',
                        component: () => import('./components/pages/especialidades/Especialidad.vue'),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
    
                       
                    },
                    {
                        path: '/especialidades',
                        name: 'Especialidades',
                        component: () => import("./components/pages/especialidades/EspecialidadesPage.vue"),
                         props: true,
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/equiposMarcas',
                        name: 'EquiposMarcas',
                        component: () => import("./components/pages/configuracion/equiposmarcas/EquiposMarcasPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
            
                    },
                    {
                        path: '/gestorTipos',
                        name: 'GestorTipos',
                        component: () => import("./components/pages/configuracion/gestortipo/gestortiposPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/SMS',
                        name: 'SMS',
                        component: () => import("./components/pages/configuracion/sms/sms.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/centralita',
                        name: 'Centralita',
                        component: () => import("./components/pages/configuracion/centralita/centralita.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/escritorio',
                        name: 'Escritorio',
                        props: tipo_buscador => ({tipo_buscador}),
                        component: () => import("./components/pages/escritorio/Escritorio.vue"),
                    },
                    {
                        path: '/Eventos',
                        name: 'Eventos',
                        component: () => import("./components/pages/configuracion/eventos/Eventos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/Encuestas',
                        name: 'Encuestas',
                        component: () => import("./components/pages/configuracion/encuestas/Encuestas.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/DocumentacionRequerida',
                        name: 'Documentación Requerida',
                        component: () => import("./components/pages/configuracion/documentacionrequerida/DocumentacionRequerida.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/GestionDocumentos',
                        name: 'Gestión Documentos',
                        component: () => import("./components/pages/configuracion/gestiondocumentos/GestionDocumentos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/AutoVisitas',
                        name: 'Auto Visitas',
                        component: () => import("./components/pages/configuracion/autovisitas/AutoVisitas.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/GestionCampos',
                        name: 'Gestión Campos',
                        component: () => import("./components/pages/configuracion/gestioncampos/GestionCampos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                   /* {
                        path: '/servicios',
                        name: 'Servicios',
                        props: ({servicios: true}), 
                        component: () => import("./components/pages/escritorio/Escritorio.vue"),
                    },*/
                    /*   {
                        path: '/planning',
                        name: 'Planning',
                        component: () => import("./components/pages/servicios/planning/planning.vue"),
                    },*/
                    {
                        path: '/planningGeografico',
                        name: 'Planning Geográfico',
                        component: () => import("./components/pages/planninggeografico/PlanningGeografico.vue"),
                    },
                    {
                        path: '/facturacionOperarios',
                        name: 'Autofacturación Operarios',
                        component: () => import("./components/pages/facturacionoperarios/FacturacionOperarios.vue"),
                    },
                    {
                        path: '/liquidacionOperarios',
                        name: 'Liquidación Operarios',
                        component: () => import("./components/pages/liquidacionoperarios/LiquidacionOperarios.vue"),
                    },
                    {
                        path: '/informesAutovisitas',
                        name: 'Informes Autovisitas',
                        component: () => import("./components/pages/informesautovisitas/InformesAutovisitas.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeAgendas',
                        name: 'Informe Agendas',
                        component: () => import("./components/pages/informeagendas/InformeAgendas.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeCalidadOperarios',
                        name: 'Informe Calidad Operarios',
                        component: () => import("./components/pages/informecalidadoperarios/InformeCalidadOperarios.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeGremiosExpediente',
                        name: 'Informe Gremios por Expediente',
                        component: () => import("./components/pages/informegremiosexpediente/InformeGremiosExpediente.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeRentabilidadGlobal',
                        name: 'Informe Rentabilidad Global',
                        component: () => import("./components/pages/informerentabilidadglobal/InformeRentabilidadGlobal.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeRentabilidadGlobalFacturacion',
                        name: 'Informe Rentabilidad Global de Facturación',
                        component: () => import("./components/pages/informerentabilidadglobalfacturacion/InformeRentabilidadGlobalFacturacion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                      {
                        path: '/informeTipoDanyos',
                        name: 'Informe Tipos de Daños',
                        component: () => import("./components/pages/informetipodanyos/InformeTipoDanyos.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeTramitacion',
                        name: 'Informe Tramitacion',
                        component: () => import("./components/pages/informetramitacion/InformeTramitacion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeRentabilidadOperarios',
                        name: 'Informe Rentabilidad Operarios',
                        component: () => import("./components/pages/informerentabilidadoperarios/InformeRentabilidadOperarios.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeRentabilidadOperariosCompanyias',
                        name: 'Informe Rentabilidad Operarios Companyias',
                        component: () => import("./components/pages/informerentabilidadoperarioscompanyias/InformeRentabilidadOperariosCompanyias.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeRentabilidadTrabajosOperariosCompanyias',
                        name: 'Informe Rentabilidad Trabajos Operarios Companyias',
                        component: () => import("./components/pages/informerentabilidadtrabajosoperarioscompanyias/informerentabilidadtrabajosoperarioscompanyias.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeTrabajosNoLiquidados',
                        name: 'Informe Trabajos No Liquidados',
                        component: () => import("./components/pages/informetrabajosnoliquidados/InformeTrabajosNoLiquidados.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeTrabajosSubsanadosCompanyia',
                        name: 'Informe Trabajos Subsanados',
                        component: () => import("./components/pages/informetrabajossubsanadoscompanyia/InformeTrabajosSubsanadosCompanyia.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                     {
                        path: '/informeBaremos',
                        name: 'Informe Baremos',
                        component: () => import("./components/pages/informebaremos/InformeBaremos.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeFichajes',
                        name: 'Informe Fichajes',
                        component: () => import("./components/pages/informefichajes/InformeFichajes.vue"),
                    },
                    {
                        path: '/facturacionAlbaranes',
                        name: 'Albaranes',
                        component: () => import("./components/pages/facturacionalbaranes/FacturacionAlbaranes.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/informeVerifactu',
                        name: 'Informe Verifactu',
                        component: () => import("./components/pages/informeverifactu/InformeVerifactu.vue"),
                    },
                    {
                        path: '/informeSatisfaccion',
                        name: 'Informe Satisfacción',
                        component: () => import("./components/pages/informesatisfaccion/InformeSatisfaccion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/facturacion',
                        name: facturacion,
                        component: () => import("./components/pages/Facturacion.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}

                    },
                    {
                        path: '/peritos',
                        name: 'Peritos',
                        component: () => import("./components/pages/peritos/PeritosPage.vue"),
                    },
                    {
                        path: '/peritos/:id',
                        name: 'Perito',
                        component: () => import("./components/pages/peritos/Perito.vue"),
                         props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },                    
                    {
                        path: '/comerciales',
                        name: 'Comerciales',
                        component: () => import("./components/pages/comerciales/ComercialesPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                        
                    },
                    {
                        path: '/comerciales/:id',
                        name: 'comercial',
                        component: () => import("./components/pages/comerciales/Comercial.vue"),
                         props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/empresas',
                        name: 'Empresas',
                        component: () => import("./components/pages/empresas/EmpresasPage.vue"),
                    },                                    
                    {
                        path: '/empresaprincipal',
                        name: 'DatosEmpresa',
                        component: () => import("./components/pages/empresaprincipal/DatosEmpresa.vue"),
                    },
                    {
                        path: '/empresas/:id',
                        name: 'Empresa',
                        component: () => import("./components/pages/empresas/Empresa.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/RGA',
                        name: 'RGA',
                        target: "_blank",
                        component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/modulos/plataforma_pas/plataforma_pas.php";
                             window.open(aux,'_blank');
                        }
                    },
                    {
                        path: '/Informes',
                         name: 'Informes',
                         target: "_blank",
    
                         component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/informes.php";
                             window.open(aux,'_blank');
                                }
                       
                    },
                    {
                        path: '/Control',
                         name: 'Control',
                         target: "_blank",
    
                         component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/informes_control.php";
                             window.open(aux,'_blank');
                                }
                       
                    },
                    {
                        path: '/seguimientoTramitadores',
                        name: 'Seguimiento Tramitadores',
                        component: () => import("./components/pages/SeguimientoTramitadores.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoOperarios',
                        name: 'Seguimiento Operarios',
                        component: () => import("./components/pages/SeguimientoOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoAlarmasUsuarios',
                        name: 'Seguimiento Alarmas Usuarios',
                        component: () => import("./components/pages/SeguimientoAlarmasUsuarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoAlarmasOperarios',
                        name: 'Seguimiento Alarmas Operarios',
                        component: () => import("./components/pages/SeguimientoAlarmasOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/seguimientoSms',
                        name: 'Seguimiento SMS',
                        component: () => import("./components/pages/SeguimientoSms.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/GuardiasOperarios',
                        name: 'Guardias Operarios',
                        component: () => import("./components/pages/GuardiasOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/vacaciones',
                        name: 'Vacaciones',
                        component: () => import("./components/pages/controlvacaciones/VacacionesPage.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/periodosOcupadosOperarios',
                        name: 'Periodos Ocupados Operarios',
                        component: () => import("./components/pages/PeriodosOcupadosOperarios.vue"),
                        meta: { permisos: ['soporte']}
                    },
                   /*  {
                        path: '/bloqueos',
                         name: 'Bloqueos',
                         target: "_blank",
    
                         component: () => {
                             let direccion = localStorage.getItem('direccion');
                             let aux = "https://" + direccion + "/planning_mensual.php?bloqueos=si";
                             window.open(aux,'_blank');
                                },
                        meta: { permisos: ['soporte']}
                        
                       
                    },*/
                    {
                        path: '/bloqueos',
                        name: 'Bloqueos',
                            
                        component: () => import("./components/pages/BloqueosPage.vue"),
                        
                       
                    },
                    {
                        path: '/bancos',
                        name: 'Bancos',
                        component: () => import("./components/pages/bancos/BancosPage.vue"),
                    },
                    {
                        path: '/bancos/:id',
                        name: 'Banco',
                        component: () => import("./components/pages/bancos/Banco.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    ///
                    {
                        path: '/correos',
                        name: 'Correos',
                        component: () => import("./components/pages/correos/CorreosPage.vue"),
                        meta: { permisos: ['Super Administración']}
                    },
                    {
                        path: '/ste',
                        name: 'Sigue tu expediente',
                        component: () => import("./components/pages/ste/ste.vue"),
                        meta: { permisos: ['soporte', 'Super Administración']}
                    },
                    {
                        path: '/interpwgs',
                        name: 'Interpwgs',
                        component: () => import("./components/pages/interpwgs/Interpwgs.vue"),
                        meta: {permisos: ['soporte']}
                    },
                    {
                        path: '/correos/:id',
                        name: 'Correo',
                        component: () => import("./components/pages/correos/Correos.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Super Administración']
                        }
                    }, 
                    {
                        path: '/planning',
                        name: 'Planning',
                        component: () => import("./components/pages/PlanningPage.vue"),
                    },
                    {
                        path: '/whatsapp',
                        name: 'WhatsApp',
                        component: () => import("./components/pages/WhatsAppPage.vue"),
                    },  
                    {
                        path: '/chat',
                        name: 'Chat',
                        component: () => import("./components/pages/ChatPage.vue"),
                    },     
                    {
                        path: '/configuracion',
                        name: 'Configuración',
                        component: () => import("./components/pages/configuracion/Configuracion.vue"),
                    },
                    {
                        path: '/clientes',
                        name: 'Clientes',
                        component: () => import("./components/pages/clientes/ClientesPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/clientes/:id',
                        name: 'Cliente',
                        component: () => import("./components/pages/clientes/Cliente.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                        }
                    },
                    {
                        path: '/configuracion-exportacion',
                        name: 'Exportación contable',
                        component: () => import("./components/pages/configuracion/facturacion/exportacion.vue"),
                    },
                    {
                        path: '/lineasfacturacion',
                        name: 'Líneas '+facturacion,
                        component: () => import("./components/pages/lineasfacturacion/LineasFacturacionPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/lineasfacturacion/:id',
                        name: 'Línea '+facturacion,
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/lineasfacturacion/crear',
                        name: 'Crear Líneas '+facturacion,
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ({id: 0}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    //Se usa???
                    {
                        path: '/lineasverifactu',
                        name: 'Líneas VeriFactu',
                        component: () => import("./components/pages/lineasfacturacion/LineasFacturacionPage.vue"),
                        props: ruta => ({id:+ruta.params.id,verifactu:1}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/lineasverifactu/:id',
                        name: 'Línea VeriFactu',
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ruta => ({id:+ruta.params.id,verifactu:1}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/lineasverifactu/crear',
                        name: 'Crear Líneas VeriFactu',
                        component: () => import("./components/pages/lineasfacturacion/LineaFacturacion.vue"),
                        props: ({id:0,verifactu:1}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/mensajespredefinidos',
                        name: 'Mensajes Predefinidos',
                        component: () => import("./components/pages/configuracion/mensajespredefinidos/MensajesPredefinidosLista.vue"),
                        meta: {permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/mensajespredefinidos/:id',
                        name: 'Mensaje Predefinido',
                        component: () => import("./components/pages/configuracion/mensajespredefinidos/MensajePredefinido.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/proveedores',
                        name: 'Proveedores',
                        component: () => import("./components/pages/proveedores/ProveedoresPage.vue"),
                    },
                    {
                        path: '/proveedores/:id',
                        name: 'Proveedor',
                        component: () => import("./components/pages/proveedores/Proveedor.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        
                        path: '/operarios',
                        name: 'Operarios',
                        component: () => import("./components/pages/operarios/OperariosPage.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/operarios/:id',
                        name: 'Operario',
                        component: () => import("./components/pages/operarios/Operario.vue"),
                       props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Facturación', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/estadospendientes',
                        name: 'Estados Pendientes',
                        component: () => import("./components/pages/configuracion/estadospendientes/EstadosPendientesPage.vue"),
                        meta: { permisos: ['soporte']}
                    },
                    {
                        path: '/estadospendientes/:id',
                        name: 'Estado Pendiente',
                        component: () => import("./components/pages/configuracion/estadospendientes/EstadosPendientes.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['soporte']
                        }
                    },
                    {
                        path: '/tiposdanyo',
                        name: 'Tipos de daño',
                        component: () => import("./components/pages/configuracion/tiposdanyo/TiposDanyoPage.vue"),
                        meta: { permisos: ['soporte', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/coberturasoperarios',
                        name: 'CoberturasOperarios',
                        component: () => import("./components/pages/configuracion/coberturasoperarios/CoberturasOperarios.vue"),
                        meta: { permisos: ['Facturación', 'Administración', 'Super Administración']}
                    },
                    {
                        path: '/tiposdanyo/:id',
                        name: 'Tipo Daño',
                        component: () => import("./components/pages/configuracion/tiposdanyo/TiposDanyos.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['soporte', 'Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/condiciones',
                        name: 'Condiciones Presupuestos',
                        component: () => import("./components/pages/configuracion/condicionespresupuestos/CondicionesPresupuestosPage.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                    {
                        path: '/condiciones/:id',
                        name: 'Condición Presupuesto',
                        component: () => import("./components/pages/configuracion/condicionespresupuestos/CondicionesPresupuestos.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id,
                            permisos: ['Administración', 'Super Administración']
                        }
                    },
                    {
                        path: '/test',
                        name: 'Test',
                        component: () => import("./components/pages/TestPage.vue"),
                    },
                    {
                        path: '/:notFound(.*)',
                        component: () => import("./components/pages/NotFound.vue"),
                    },
                    {
                        path: '/pedidos',
                        name: 'Pedidos',
                        component: () => import("./components/pages/pedidos/Pedidos.vue"),
                    },
                    {
                        path: '/servicio/:id',
                        name: 'Nuevo servicio',
                        component: () => import("./components/pages/servicios/NuevoServicio.vue"),
                        props: ruta => ({id: +ruta.params.id}), // pasamos id de string a number
                        meta: {
                            titulo: ruta => ruta.params.id
                        }
                    },
                    {
                        path: '/festivos',
                        name: 'Festivos',
                        component: () => import("./components/pages/festivos/Festivos.vue"),
                        meta: { permisos: ['Administración', 'Super Administración']}
                    },
                ]
            },
    
    
            {
                path: '/:notFound(.*)',
                component: () => import("./components/pages/NotFound.vue"),
            },
        ]
    });
}

router.beforeEach((to, from, next) => {
    // acciones 
    let irALogin = false;
    if (to.name === 'login') {
        irALogin = true;
    }
   
    const token = localStorage.getItem('token');
    
     
    
   
    if (!token && !irALogin) {
        next({ name: 'login' });
    }
    else if (irALogin && token) {
        next({ name: 'Inicio' });
    }
    else if (to.meta.permisos) {
        const permisosUsuario = JSON.parse(localStorage.getItem('permisos') || '[]');
        const tieneAcceso = to.meta.permisos.some(p => permisosUsuario.includes(p));
        if(!tieneAcceso) {
            next({name: 'Escritorio'});
        }else {
            next();
            if (from.fullPath.match(/(nueva|nuevo|crear)/)) {
                store.dispatch('reemplazarVentana', { from, to });
            } else {
                if (to.name != 'login') {
                    store.dispatch('agregarVentana', to);
                }
            }
        }
    }
  
  
    else {
        next();
        if (from.fullPath.match(/(nueva|nuevo|crear)/)) {
            store.dispatch('reemplazarVentana', {
                from, 
                to,
            });
        }
        else {
            if (to.name != 'login'){
                store.dispatch('agregarVentana', to);
                }
        }
    }
});

export default router;